import * as React from "react";
import { useState } from "react";
import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { ResultPageModel } from "../../../../../Wrap/Core/SortingAndPaging/Models/ResultPageModel";
import { DepositProduct } from "../../../../../Wrap/Models/Domains/Investment/DepositProduct";
import { Investment } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { DepositDetailsPopupModal } from "../../../../Dashboard/Components/Clients/Common/DepositDetailsPopUp/DepositDetailsPopupModal";
import { Table } from "../../../Table/Table";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
import { MoneyDisplayHelper } from "../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { DepositProductType } from "../../../../../Wrap/Constants/Enums/Domain/DepositProductType";
import { AriaTooltip } from "../../../Tooltip/AriaTooltip";

interface IDepositsSearchResultsProps {
    data: ResultPageModel<DepositProduct>;
    allocationTable: any[];
    onPageChange: (pageIndex) => void;
    isFavourite?: boolean;
    index: number;
    researchIst: boolean;
    currentPage: number;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}
export const DepositSearchResults = (props: IDepositsSearchResultsProps) => {
    const [isShowDetailModal, setShow] = React.useState(false);
    const [selectedInvestment, setSelected] = React.useState<DepositProduct>(null);

    const [code, setCode] = useState({ key: "ProductCode", value: "CashDeposit code" });
    const [data, setData] = useState<ResultPageModel<DepositProduct>>(null);

    React.useEffect(() => {
        const _data = JSON.parse(JSON.stringify(props.data));
        const curData = JSON.parse(JSON.stringify(data));
        _data.Results = props.data.Results.map((ele) => {
            const isSelected = props.allocationTable.some(
                (item) => item.Instrument?.ProductId == ele.ProductId || item.Investment?.ProductId == ele.ProductId
            );
            const curItem = (curData?.Results ?? []).find((item) => item.ProductId == ele.ProductId);
            const isFav = curItem ? curItem.IsFavourite : ele.IsFavourite;
            return { ...ele, isSelected: isSelected, IsFavourite: isFav };
        });

        setData(_data);
    }, [props.allocationTable]);

    React.useEffect(() => {
        const _data = JSON.parse(JSON.stringify(props.data));
        _data.Results = props.data.Results.map((ele) => {
            const isSelected = props.allocationTable.some(
                (item) => item.Instrument?.ProductId == ele.ProductId || item.Investment?.ProductId == ele.ProductId
            );
            return { ...ele, isSelected: isSelected };
        });

        setData(_data);
    }, [props.data]);

    const renderInvestmentDetailPopupModal = (): JSX.Element => {
        if (!isShowDetailModal) {return null;}
        return (
            <>
                <DepositDetailsPopupModal
                    showBox={isShowDetailModal}
                    callBack={() => {
                        setShow(false);
                    }}
                    instrumentCode={selectedInvestment?.ProductCode}
                    productId={selectedInvestment?.ProductId}
                    issuer={selectedInvestment?.Issuer}
                    depositType={selectedInvestment?.DepositProductType}
                    term={selectedInvestment?.Term}
                    grossRate={selectedInvestment?.GrossInterestRate}
                    aerRate={selectedInvestment?.AnnualEquivalentInterestRate}
                    minimumInvestment={selectedInvestment?.MinimumInvestment}
                    maximumInvestment={selectedInvestment?.MaximumInvestment}
                    instrumentName={selectedInvestment?.Name}
                />
            </>
        );
    };

    const onInvestmentSelected = (depositProduct) => {
        setSelected(depositProduct);
        setShow(true);
    };

    const interestRateHeader = (): JSX.Element =>
    {
        return (
            <>
                <div>
                    AER | Gross
                    <AriaTooltip cssWrapper="is-info-icon">
                        {
                            <small>AER stands for Annual Equivalent Rate. The AER illustrates what the interest rate would be if interest was paid and compounded once each year. It helps you compare interest rates across different products.  <strong>Note:</strong> As part of our range of deposit takers, we have Sharia products which offer an expected profit rate, rather than interest on their savings products, in order to comply with Sharia banking principles.</small>
                        }
                    </AriaTooltip>
                </div>
            </>
        );
    }

    const codeOptions = [
        { key: "ProductCode", value: "CashDeposit code" },
        { key: "Isin", value: "ISIN" },
        { key: "Sedol", value: "SEDOL" },
        { key: "ProductId", value: "Mex ID" },
    ];
    return (
        <div className="panel pr-0 pl-0 pb-0 pt-0 mt-40">
            <h3>{props.isFavourite ? "Favourites list" : "Selection"}</h3>
            <p>Cash deposits available: {props.data.Pager.TotalRecords}</p>
            <Table
                data={data?.Results}
                cssWrapper={"no-sided-padding has-favourite-toggle"}
                showEmptyMsg
                cssEmptyMessage="warning-message mt-20"
                needPagination={{
                    totalNumOfResult: props.data.Pager.TotalRecords,
                    currentPage: props.currentPage,
                    onPaginationChange: (pageIndex) => {
                        props.setCurrentPage(pageIndex);
                        props.onPageChange(pageIndex);
                    },
                }}
                col={[
                    {
                        title: "Provider",
                        key: "Name",

                        render: (rowData, row, index) => {
                            return (
                                <a className="hyperlink" onClick={() => onInvestmentSelected(row)}>
                                    {rowData}
                                </a>
                            );
                        },
                    },
                    props.researchIst
                        ? {
                              title: "ISIN",
                              key: "Isin",
                          }
                        : null,
                    props.researchIst
                        ? {
                              title: "CashDeposit type",
                              key: "CashDepositType",
                          }
                        : null,
                    props.researchIst
                        ? {
                              title: "AMC",
                              key: "AMC",
                          }
                        : null,
                    props.researchIst
                        ? {
                              title: "TER",
                              key: "TER",
                          }
                        : null,
                    props.researchIst
                        ? {
                              title: "OCF",
                              key: "OCF",
                          }
                        : null,
                    props.researchIst
                        ? {
                              title: "Asset class",
                              key: "AssetClass",
                          }
                        : null,
                    {
                        title: "Type",
                        key: "DepositProductType",
                        render: (rowData, row, index) => {
                            switch(rowData) {
                                case DepositProductType.EasyAccess:
                                    return <>Easy access</>
                                case DepositProductType.Notice:
                                    return <>Notice account</>;
                                case DepositProductType.Term:
                                    return <>Fixed term</>
                            }
                        }
                    },
                    {
                        title: interestRateHeader(),
                        key: "GrossInterestRate",
                        render: (rowData, row, index) => {
                            return (
                                <>{MoneyDisplayHelper.getPercentageFormat(row.AnnualEquivalentInterestRate, 2)} | {MoneyDisplayHelper.getPercentageFormat(rowData, 2)}</>
                            );
                        },
                     },
                    {
                        title: "Term / Notice",
                        key: "Term",
                        render: (rowData, row, index) =>
                        {
                            switch (row.DepositProductType)
                            {
                                case DepositProductType.EasyAccess:
                                    return <>N/A</>
                                case DepositProductType.Notice:
                                    return <>{rowData} days</>;
                                case DepositProductType.Term:
                                    if (rowData == 12)
                                    {
                                        return <>1 year</>
                                    }
                                    else if (rowData == 1)
                                    {
                                        return <>1 month</>
                                    }
                                    else if (rowData % 12 == 0)
                                    {
                                        return <>{rowData / 12} years</>
                                    }
                                    else
                                    {
                                        return <>{rowData} months</>
                                    }
                            }
                        },
                    },
                    {
                        title: "Min opening amount",
                        key: "MinimumInvestment",
                        render: (rowData, row, index) => {
                            return (
                                <>{MoneyDisplayHelper.FromatMoneyDisplay(rowData, CurrencyCode.GBP, true, 0)}</>
                            );
                        },
                    },
                    {
                        title: "Interest paid",
                        key: "Type",
                        render: (rowData, row, index) => {
                            switch(row.DepositProductType) {
                                case DepositProductType.EasyAccess:
                                case DepositProductType.Notice:
                                    return <>Daily</>;
                                case DepositProductType.Term:
                                    return <>Maturity</>;
                            }
                        }
                    },
                    props.researchIst
                        ? {
                              title: "Status",
                              key: "",
                              render: (data) => {
                                  return "Tradeable";
                              },
                          }
                        : null,
                    !props.researchIst
                        ? {
                              title: <span className="sr-only">select an investment</span>,
                              key: "isSelected",
                              render: (data, row) => {
                                  return (
                                      <a
                                          className={"select-toggle"}
                                          onClick={() => {
                                              if (data) {return null;}
                                              if (props.index) {
                                                  InvestmentSelectionAction.setEditingTransferNumber(props.index);
                                              }
                                              InvestmentSelectionAction.addInvestment(row);
                                          }}
                                          aria-pressed={data}
                                      >
                                          <span className="label">{data ? "Added" : "Select"}</span>
                                      </a>
                                  );
                              },
                          }
                        : null,
                ]}
            />
            {renderInvestmentDetailPopupModal()}
        </div>
    );
};
